// extracted by mini-css-extract-plugin
export default {"title":"styles_title__XEsrr","container":"styles_container__Wu6ND","content":"styles_content__-yHYr","aside":"styles_aside__Z81hM","rot":"styles_rot__AGqhV"};